import { CustomerVatRegime } from '../../interfaces/customer.interface';

export const getVatRegimeObject = (data: CustomerVatRegime[], id: number) => {
  const vatRegimeObject = data.find((curr) => curr.id === id);

  return vatRegimeObject || data[0];
};
